import React, { useState, useEffect } from 'react';
import InvoiceInput from '../../components/Invoicing/InvoiceInput'
import { useLocation } from 'react-router-dom';
import { CommonHeader, Loader, ErrorSuccessModal } from '../../components/commons';
import { connect } from 'react-redux';
import { RootState } from '../../redux/rootReducers';
import { InvoiceColumnsType } from '../../redux/invoicing/invoicingTypes';
import { resetSession } from '../../redux/auth';
import {
  resetInvoiceStatusCode,
  resetInvoicingError,
  resetInvoicingSuccess
} from '../../redux/invoicing';

type AppProps = {
  individualColumnList: InvoiceColumnsType;
  history?: any;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetSession: () => void;
  dispatchResetInvoiceStatusCode: () => void;
  dispatchResetInvoicingError: () => void;
  dispatchResetInvoicingSuccess: () => void;
}

type ColumnListType = {
  id?: number;
  name?: string;
  column_name?: string;
  data_type?: string;
  column_value?: any;
  placeholder?: string;
}

const AddInvoice = ({
  individualColumnList,
  history,
  fetching,
  success,
  error,
  statusCode,
  dispatchResetSession,
  dispatchResetInvoicingSuccess,
  dispatchResetInvoiceStatusCode,
  dispatchResetInvoicingError
}: AppProps) => {
      const {
      location = {}
    } = history
  const search = useLocation().search ;
  const type = new URLSearchParams(search).get('type') ? new URLSearchParams(search).get('type')  : (location?.pathname?.split("=")[1]);
  const [finalColumnList, setFinalColumnList] = useState<ColumnListType[] | []>([]);

  const client_url = window.location.pathname.split("/")
  let client_code = client_url && client_url[client_url.length - 1]

  useEffect(() => {
    dispatchResetInvoicingError();
    dispatchResetInvoicingSuccess();
    dispatchResetInvoiceStatusCode();
  }, []);

  useEffect(() => {
    if (type === 'expenses') {
      setFinalColumnList(individualColumnList.expenses);
    }
    else if (type === 'others') {
      setFinalColumnList(individualColumnList.others);
    }
    else {
      setFinalColumnList(individualColumnList.revenue);
    }
  }, [individualColumnList]);

  const redirectToListing = () => {
    history.goBack();
  }

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetInvoicingError();
            }}
            statusCode={statusCode}
          />
        )
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => dispatchResetInvoicingError()}
          />
        )
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Invoice Added Successfully!"
          buttonText="OK"
          onPress={() => {
            dispatchResetInvoicingSuccess();
            redirectToListing();
          }}
          statusCode={statusCode}
        />
      )
    }

    return false;
  }

  return (
    <>
      {finalColumnList && finalColumnList !== undefined ?
        <InvoiceInput
          finalColumnList={finalColumnList}
          type={type}
          client_code={client_code}
          history={history}
        /> : null
      }
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  )
}

const mapStateToProps = (state: RootState) => ({
  individualColumnList: state.invoicing.individualColumnList,
  fetching: state.invoicing.fetching,
  success: state.invoicing.success,
  error: state.invoicing.error,
  statusCode: state.invoicing.statusCode
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode()),
  dispatchResetInvoicingError: () => dispatch(resetInvoicingError()),
  dispatchResetInvoicingSuccess: () => dispatch(resetInvoicingSuccess())
})

export default connect(mapStateToProps, mapDispatchToProps)(AddInvoice);